module.exports = __webpack_public_path__ + "img/no_data.78bef72c.c9f5f0b0.svg";